<template>
    <div style="background: white; border-radius: 5px;">
        <HeaderStudentTaxInvoice @getListTaxInvoice="getTaxInvoiceList"/>
        <hr style="padding: 0; margin: 0"/>
        <div v-loading="loading" style="padding:15px 20px">
            <div style="display: flex; flex-direction: column; gap: 15px; padding: 10px 0">
                <div class="grid-filter">

                    <div class="display-flex-column">
                        <span>Tên khách hàng</span>
                        <el-input
                            v-model="queryFilter.user_name"
                            clearable
                            placeholder="Nhập tên khách hàng"
                            suffix-icon="el-icon-search"
                            @change="handleSearch"
                        >
                        </el-input>
                    </div>
                    <div class="display-flex-column">
                        <span>Số điện thoại</span>
                        <el-input
                            v-model="queryFilter.phone"
                            clearable
                            placeholder="Nhập số điện thoại"
                            suffix-icon="el-icon-search"
                            @change="handleSearch"
                        >
                        </el-input>
                    </div>
                    <div class="display-flex-column">
                        <span>Trung tâm</span>
                        <el-select v-model="queryFilter.center_id" clearable multiple placeholder="Chọn chọn trung tâm"
                                   style="width: 100%" @change="handleSearch">
                            <el-option
                                v-for="item in centers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="display-flex-column">
                        <span>Năm </span>
                        <el-date-picker
                            v-model="queryFilter.year"
                            format="yyyy"
                            placeholder="Chọn năm"
                            type="year"
                            value-format="yyyy"
                            @change="handleSearch">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="example-preview table-responsive h-100 mt-8">
                <table class="table table-vertical-center table-bordered">
                    <thead>
                    <tr style="background-color: #F8F8F8;">
                        <th class="min-w-[80px]" scope="col"
                            style="background: #F8F8F8;white-space: nowrap; text-align: start">Mã học viên
                        </th>
                        <th class="min-w-[80px]" scope="col"
                            style="background: #F8F8F8;white-space: nowrap; text-align: start">Tên khách hàng
                        </th>
                        <th class="min-w-[40px]" scope="col" style="background: #F8F8F8; text-align: start;">Số điện
                            thoại
                        </th>
                        <th class="min-w-[40px]" scope="col" style="background: #F8F8F8; text-align: start;">Trạng
                            thái
                        </th>
                        <th class="min-w-[40px]" scope="col" style="background: #F8F8F8; text-align: start;">Loại hợp
                            đồng
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start">Tổng giá
                            khoá
                        </th>
                        <th class="min-w-[80px]" scope="col"
                            style="background: #F8F8F8; text-align: start; white-space: nowrap">Tông số tiền nạp rút
                        </th>
                        <th class="min-w-[80px]" scope="col"
                            style="background: #F8F8F8; text-align: start; white-space: nowrap">Trung tâm
                        </th>
                        <th class="min-w-[120px]" scope="col"
                            style="background: #F8F8F8; text-align: start; white-space: nowrap">Mã hợp đồng
                        </th>
                        <th class="min-w-[150px]" scope="col" style="background: #F8F8F8; text-align: start">Khoá học
                            1
                        </th>
                        <th class="min-w-[150px]" scope="col" style="background: #F8F8F8; text-align: start">Khoá học
                            2
                        </th>
                        <th class="min-w-[150px]" scope="col" style="background: #F8F8F8; text-align: start">Khoá học
                            3
                        </th>
                        <th class="min-w-[150px]" scope="col" style="background: #F8F8F8; text-align: start">Khoá học
                            4
                        </th>
                        <th class="min-w-[150px]" scope="col" style="background: #F8F8F8; text-align: start">Khoá học
                            5
                        </th>
                        <th class="w-100px" scope="col" style="background: #F8F8F8">Hành động</th>
                    </tr>
                    </thead>
                    <tbody v-if="TaxInvoiceList?.length > 0">
                    <tr v-for="invoice of TaxInvoiceList" :key="invoice?.id"
                        style="border: 1px solid #EBEDF3; border-top: 0">
                        <td style="text-align: start">
                            {{ invoice.user_id }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.ten_khach_hang }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.so_dien_thoai }}
                        </td>
                        <td>
                            Đã phát hành
                        </td>
                        <td>
                            <el-tooltip v-if="invoice.nguoi_chuyen_nhuong_id > 0" placement="top">
                                <template #content>
                                    <div>
                                        <p style="height: 13px">Mã người chuyển: {{
                                                invoice.nguoi_chuyen_nhuong_id
                                            }}</p>
                                        <p style="height: 13px">Tên người chuyển: {{
                                                invoice.ten_nguoi_chuyen_nhuong
                                            }}</p>
                                        <p style="height: 13px">Số điện thoại người chuyển:
                                            {{ invoice.so_dien_thoai_nguoi_chuyen_nhuong }}</p>
                                    </div>
                                </template>
                                <el-tag type="success">HĐ chuyển nhượng</el-tag>
                            </el-tooltip>
                            <el-tag v-if="!invoice.nguoi_chuyen_nhuong_id ">HĐ thuờng</el-tag>
                        </td>
                        <td>
                            {{ invoice.tong_gia_khoa | formatPrice }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.tong_so_tien_dong | formatPrice }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.trung_tam }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.contract_id }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.khoa_hoc_1 }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.khoa_hoc_2 }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.khoa_hoc_3 }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.khoa_hoc_4 }}
                        </td>
                        <td style="text-align: start">
                            {{ invoice.khoa_hoc_5 }}
                        </td>
                        <td style="text-align: center">
                            <button v-if="invoice.showButton === 1" class="btn btn-icon btn-xs btn-outline-danger"
                                    title="Hủy phát hành" @click="cancelRelease(invoice, 4)">
                                <i class="el-icon-delete"></i>
                            </button>
                            <button v-if="invoice.showButton === 2" class="btn btn-icon btn-xs btn-outline-primary"
                                    title="Dừng phát hành" @click="cancelRelease(invoice, 2)">
                                <i class="fa-solid fa-stop"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td class="event-title no-data" colspan="12" style="text-align: center">Chưa có dữ liệu</td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="TaxInvoiceList?.length > 0">
                    <div class="edu-paginate mx-auto text-center mt-10 mb-5"
                         style="display: flex; justify-content: center; align-items: center; height: 50px">
                        <paginate
                            v-model="page"
                            :click-handler="changePage"
                            :container-class="'pagination b-pagination'"
                            :margin-pages="1"
                            :next-class="'page-link'"
                            :next-link-class="'next-link-item'"
                            :next-text="'Sau'"
                            :page-class="'page-item'"
                            :page-count="lastPage"
                            :page-range="3"
                            :pageLinkClass="'page-link'"
                            :prev-class="'page-link'"
                            :prev-link-class="'prev-link-item'"
                            :prev-text="'Trước'"
                        >
                        </paginate>
                    </div>
                    <div class="w-100" style="display: flex; justify-content: end; margin-top: -50px">
                        <div>
                            Tổng số bản ghi: <span
                            style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{
                                this.total ?? TaxInvoiceList.length
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {juridicalOption, statusInvoice, typeInvoice} from "@/common/define";
import {STUDENT_TAX_INVOICE,} from "@/core/services/store/tax-invoice/tax-invoice.module";
import StudentTaxInvoiceModel from "./model/StudentTaxInvoiceModel";
import {GET_CENTER_TAG_E} from "@/core/services/store/task-management/task-management.module";
import HeaderStudentTaxInvoice from "@/view/pages/tax-invoice/components/HeaderStudentTaxInvoice.vue";

export default {
    components: {HeaderStudentTaxInvoice},
    data() {
        return {
            loading: false,
            page: 1,
            lastPage: 1,
            total: 0,
            TaxInvoiceList: [],
            statusInvoice,
            typeInvoice,
            juridicalOption,
            centers: [],
            confirmCancel: false,
            taxInvoiceSelected: null,
            statusSelectedInvoice: null,
            queryFilter: {
                keyword: null,
                year: null,
                phone: null,
                center_id: null,
            },
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý báo cáo"},
            {title: "Danh sách học viên phát hành hoá đơn thuế", name: 'TaxInvoiceList'}
        ]);
        this.getTaxInvoiceList()
        this.getAllCenterActive()
    },
    methods: {
        changePage(obj) {
            this.page = obj;
            this.getTaxInvoiceList()
        },
        getTaxInvoiceList() {
            this.getParams()
            this.callApi()
        },
        async handleSearch() {
            await this.queryFilterTaxInvoice()
            this.getTaxInvoiceList()
        },

        callApi() {
            this.loading = true
            const payload = {
                page: this.page,
                keyword: this.queryFilter.keyword,
                phone: this.queryFilter.phone,
                center_id: this.queryFilter.center_id,
                year: this.queryFilter.year,
            }
            this.$store.dispatch(STUDENT_TAX_INVOICE, payload).then(res => {
                if (!res.error) {
                    const data = res.data
                    this.loading = true
                    this.page = data.current_page
                    this.lastPage = data.last_page
                    this.total = data.total
                    this.TaxInvoiceList = data.data.map(item => {
                        console.log(item);
                        return new StudentTaxInvoiceModel(item)
                    }) ?? []
                    this.totalStudent = res.total
                }
            }).catch(e => {
                console.log(e, 'error')
            }).finally(() => {
                this.loading = false
            })
        },
        getParams() {
            const query = this.$route.query
            this.queryFilter.keyword = query.keyword ?? null
            this.queryFilter.phone = query.phone ?? null
            this.queryFilter.center_id = query.center_id ?? null
            this.queryFilter.year = query.year ?? null
        },

        getAllCenterActive() {
            const payload = {
                limit: 10000,
                is_edutalk: 1,
                status: 1,
            }
            this.$store.dispatch(GET_CENTER_TAG_E, payload).then(res => {
                if (!res.error) {
                    this.centers = res.data?.data
                }
            })
        },

        async queryFilterTaxInvoice() {
            await this.$router.push({
                name: 'StudentInvoice',
                query: {
                    ...this.queryFilter,
                },
            })
        },

    }
}
</script>

<style scoped>
.bg-waiting {
    background: #FF9900;
}

.bg-success {
    background: #1BC5BD;
    color: white;
}

.bg-fail {
    background: #F50B0B;
    color: white;
}

.bg-cancel {
    color: white;
    background: #6E6E6E
}

.bg-blue-500 {
    background: #0066FF;
    color: white;
}

.display-flex-column {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.grid-filter {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    gap: 10px 60px;
}

@media screen and (max-width: 1560px) {
    .grid-filter {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 10px 30px;
    }
}
</style>